/**
 * Expands a featured-collection grid in place. A button with [data-fc-show-all]
 * removes its section's data-fc-limit so every rendered product shows, then hides itself
 * and moves focus to the first newly revealed product.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-fc-show-all]');
  if (!button) return;
  const section = button.closest('[data-fc-limit]');
  if (!section) return;
  const limit = Number(section.dataset.fcLimit) || 0;
  section.removeAttribute('data-fc-limit');
  const firstNew = section.querySelectorAll('[data-carousel-track] > *')[limit];
  button.closest('[data-fc-show-all-wrap]')?.setAttribute('hidden', '');
  firstNew?.querySelector('a[href]')?.focus({ preventScroll: true });
});
